"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.array.find-index");

require("core-js/modules/es6.array.find");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

require("core-js/modules/es6.function.name");

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _vuedraggable = _interopRequireDefault(require("vuedraggable"));

var _elementUi = require("element-ui");

var _lastMileV = require("@/mixins/last-mile-v2/last-mile-v2");

var _request = require("@/services/request/request.service");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LMDOrderTableColumnSelectorComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LMDOrderTableColumnSelectorComponent, _Mixins);

  var _super = _createSuper(LMDOrderTableColumnSelectorComponent);

  function LMDOrderTableColumnSelectorComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, LMDOrderTableColumnSelectorComponent);
    _this = _super.apply(this, arguments);
    _this.isDialogVisible = false;
    _this.unselectedColumns = [];
    _this.columnKey = 'JOBORDER';
    _this.selectedTemplateName = 'newTemplate';
    _this.newTemplateName = ''; // private orderAPI: OrderAPI = null;

    _this.requestAuth = null;
    _this.requestParameters = null;
    return _this;
  }

  (0, _createClass2.default)(LMDOrderTableColumnSelectorComponent, [{
    key: "onDialogVisibleChanges",
    value: function onDialogVisibleChanges(newVal) {
      if (!newVal) {
        this.saveColumns();
      } else {
        this.handleTemplateChanges();
      }
    }
  }, {
    key: "cardInnerHeight",
    get: function get() {
      return "".concat(document.documentElement.clientHeight * 0.75, "px");
    }
  }, {
    key: "templateNames",
    get: function get() {
      return [].concat((0, _toConsumableArray2.default)(this.$orderColumnTemplates.map(function (template) {
        return {
          title: template.name,
          value: template._id
        };
      })), [{
        title: this.$t('pickColumns.createNewTemplate'),
        value: 'newTemplate'
      }]);
    }
  }, {
    key: "created",
    value: function created() {
      this.initAPI();
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.initColumns();
    }
  }, {
    key: "initAPI",
    value: function initAPI() {
      this.requestAuth = new _request.Request('application/json', process.env.VUE_APP_SECRET_KEY_HASH);
      this.requestParameters = (0, _defineProperty2.default)({}, process.env.VUE_APP_CUSTOMER_KEY, this.$userInformation.customerKey);
    }
  }, {
    key: "initColumns",
    value: function () {
      var _initColumns = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var templateId, selectedTemplate, index, columns;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.getColumnTemplates();

              case 2:
                if (this.$orderColumnTemplates.length === 0) {
                  this.selectedTemplateName = 'newTemplate';
                  this.$selectedColumns = this.helper.cloneDeep(this.$defaultOrderColumns);
                } else {
                  templateId = window.localStorage.getItem(this.columnKey);
                  selectedTemplate = null;

                  if (!this.helper.isUndefined(templateId)) {
                    selectedTemplate = this.$orderColumnTemplates.find(function (t) {
                      return t._id === templateId;
                    });
                  }

                  this.selectedTemplateName = selectedTemplate ? selectedTemplate._id : this.$orderColumnTemplates[this.$orderColumnTemplates.length - 1]._id;
                  index = this.$orderColumnTemplates.findIndex(function (item) {
                    return item._id === _this2.selectedTemplateName;
                  });

                  if (index !== -1) {
                    columns = (0, _toConsumableArray2.default)(this.$orderColumnTemplates[index].data.columns);
                    this.$selectedColumns = this.$defaultOrderColumns.filter(function (col) {
                      return _this2.helper.includes(columns, col);
                    }).sort(function (a, b) {
                      return columns.indexOf(a) - columns.indexOf(b);
                    });
                  } else {
                    this.$selectedColumns = (0, _toConsumableArray2.default)(this.$defaultOrderColumns);
                  }

                  this.unselectedColumns = this.helper.difference(this.$defaultOrderColumns, this.$selectedColumns);
                }
                /*if (!this.hasAssemblyMinutes) {
                  this.$selectedColumns = this.$selectedColumns.filter(col => this.isColumnFilteredOut(col, 'assembly'));
                  this.unselectedColumns = this.unselectedColumns.filter(col => this.isColumnFilteredOut(col, 'assembly'));
                }*/


              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initColumns() {
        return _initColumns.apply(this, arguments);
      }

      return initColumns;
    }()
  }, {
    key: "isColumnFilteredOut",
    value: function isColumnFilteredOut(col, type) {
      if (type === 'assembly') {
        return col !== 'serviceName' && col !== 'assemblyMinutes' && col !== 'wallMountQuantity' && col !== 'disposalQuantity' && col !== 'staircaseQuantity' && col !== 'pickPhoneNumber' && col !== 'dropPhoneNumber';
      }

      return col;
    }
  }, {
    key: "handleTemplateChanges",
    value: function handleTemplateChanges() {
      var _this3 = this;

      var templateName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selectedTemplateName;

      if (templateName === 'newTemplate') {
        this.$selectedColumns = this.helper.cloneDeep(this.$defaultOrderColumns);
        this.unselectedColumns = this.helper.difference(this.$defaultOrderColumns, this.$selectedColumns);
      } else {
        this.newTemplateName = '';
        var columnTemplate = this.$orderColumnTemplates.find(function (t) {
          return t._id === templateName;
        });

        if (columnTemplate) {
          var columns = (0, _toConsumableArray2.default)(columnTemplate.data.columns);
          this.$selectedColumns = this.$defaultOrderColumns.filter(function (col) {
            return _this3.helper.includes(columns, col);
          }).sort(function (a, b) {
            return columns.indexOf(a) - columns.indexOf(b);
          });
          this.unselectedColumns = this.helper.difference(this.$defaultOrderColumns, this.$selectedColumns);
        }

        window.localStorage.setItem(this.columnKey, templateName);
      }
    }
  }, {
    key: "editColumns",
    value: function editColumns(type, column) {
      if (type === 'add') {
        this.$selectedColumns = [].concat((0, _toConsumableArray2.default)(this.$selectedColumns), [column]);
        this.unselectedColumns = this.unselectedColumns.filter(function (col) {
          return col !== column;
        });
      }

      if (type === 'remove') {
        this.$selectedColumns = this.$selectedColumns.filter(function (col) {
          return col !== column;
        });
        this.unselectedColumns.push(column);
      }
    }
  }, {
    key: "saveColumns",
    value: function saveColumns() {
      this.resetVariables();
    }
  }, {
    key: "getColumnTemplates",
    value: function () {
      var _getColumnTemplates = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this4 = this;

        var params, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                params = _objectSpread(_objectSpread({}, this.requestParameters), {}, {
                  limit: 200,
                  type: this.columnKey
                });
                _context2.next = 4;
                return this.requestAuth.get('ROUTING', "v1/core/tabletemplates", params);

              case 4:
                res = _context2.sent;

                if (!res.failed) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return", false);

              case 7:
                this.$orderColumnTemplates = this.helper.get(res, 'data', []).filter(function (i) {
                  return i.customerId === _this4.$userData.id && i.type === _this4.columnKey;
                });
                return _context2.abrupt("return", true);

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", false);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 11]]);
      }));

      function getColumnTemplates() {
        return _getColumnTemplates.apply(this, arguments);
      }

      return getColumnTemplates;
    }()
  }, {
    key: "insertColumnTemplate",
    value: function () {
      var _insertColumnTemplate = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(payload) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.requestAuth.post('ROUTING', "v1/core/tabletemplate", _objectSpread({}, this.requestParameters), payload));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function insertColumnTemplate(_x) {
        return _insertColumnTemplate.apply(this, arguments);
      }

      return insertColumnTemplate;
    }()
  }, {
    key: "updateColumnTemplate",
    value: function () {
      var _updateColumnTemplate = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(id, payload) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.requestAuth.put('ROUTING', "v1/core/tabletemplate/".concat(id), _objectSpread({}, this.requestParameters), payload));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function updateColumnTemplate(_x2, _x3) {
        return _updateColumnTemplate.apply(this, arguments);
      }

      return updateColumnTemplate;
    }()
  }, {
    key: "deleteColumnTemplate",
    value: function () {
      var _deleteColumnTemplate = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(id) {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.requestAuth.delete('ROUTING', "v1/core/tabletemplate/".concat(id), _objectSpread({}, this.requestParameters)));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function deleteColumnTemplate(_x4) {
        return _deleteColumnTemplate.apply(this, arguments);
      }

      return deleteColumnTemplate;
    }()
  }, {
    key: "updateSelectedTemplateId",
    value: function updateSelectedTemplateId(templateName) {
      this.selectedTemplateName = this.helper.get(this.$orderColumnTemplates.find(function (t) {
        return t.name === templateName;
      }), '_id', null);
    }
  }, {
    key: "postNewTemplate",
    value: function () {
      var _postNewTemplate = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var templateName, res, message;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                templateName = this.newTemplateName.trim();

                if (!this.helper.isUndefined(templateName)) {
                  _context6.next = 3;
                  break;
                }

                return _context6.abrupt("return");

              case 3:
                _context6.next = 5;
                return this.insertColumnTemplate({
                  name: templateName,
                  type: this.columnKey,
                  data: {
                    columns: this.$selectedColumns
                  }
                });

              case 5:
                res = _context6.sent;
                message = {
                  title: this.$i18n.t('notification.columnTemplate.insertSuccess'),
                  duration: 5000
                };

                if (!(res.status === 'success')) {
                  _context6.next = 14;
                  break;
                }

                _context6.next = 10;
                return this.getColumnTemplates();

              case 10:
                this.updateSelectedTemplateId(templateName);

                _elementUi.Notification.success(message);

                _context6.next = 16;
                break;

              case 14:
                message.title = this.$i18n.t('notification.columnTemplate.insertFailed');

                _elementUi.Notification.error(message);

              case 16:
                this.resetVariables();

              case 17:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function postNewTemplate() {
        return _postNewTemplate.apply(this, arguments);
      }

      return postNewTemplate;
    }()
  }, {
    key: "putCurrentTemplate",
    value: function () {
      var _putCurrentTemplate = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var _this5 = this;

        var templateName, res, message;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                templateName = this.helper.get(this.$orderColumnTemplates.find(function (t) {
                  return t._id === _this5.selectedTemplateName;
                }), 'name', null);

                if (!this.helper.isUndefined(templateName)) {
                  _context7.next = 3;
                  break;
                }

                return _context7.abrupt("return");

              case 3:
                _context7.next = 5;
                return this.updateColumnTemplate(this.selectedTemplateName, {
                  name: templateName,
                  type: this.columnKey,
                  data: {
                    columns: this.$selectedColumns
                  }
                });

              case 5:
                res = _context7.sent;
                message = {
                  title: this.$i18n.t('notification.columnTemplate.updateSuccess'),
                  duration: 5000
                };

                if (!(res.status === 'success')) {
                  _context7.next = 14;
                  break;
                }

                _context7.next = 10;
                return this.getColumnTemplates();

              case 10:
                this.updateSelectedTemplateId(templateName);

                _elementUi.Notification.success(message);

                _context7.next = 16;
                break;

              case 14:
                message.title = this.$i18n.t('notification.columnTemplate.updateFailed');

                _elementUi.Notification.error(message);

              case 16:
                this.resetVariables();

              case 17:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function putCurrentTemplate() {
        return _putCurrentTemplate.apply(this, arguments);
      }

      return putCurrentTemplate;
    }()
  }, {
    key: "deleteCurrentTemplate",
    value: function () {
      var _deleteCurrentTemplate = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var _this6 = this;

        var templateName, res, message;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                templateName = this.helper.get(this.$orderColumnTemplates.find(function (t) {
                  return t._id === _this6.selectedTemplateName;
                }), 'name', null);

                if (!this.helper.isUndefined(this.selectedTemplateName)) {
                  _context8.next = 3;
                  break;
                }

                return _context8.abrupt("return");

              case 3:
                _context8.next = 5;
                return this.deleteColumnTemplate(this.selectedTemplateName);

              case 5:
                res = _context8.sent;

                if (!this.helper.isUndefined(templateName)) {
                  _context8.next = 8;
                  break;
                }

                return _context8.abrupt("return");

              case 8:
                message = {
                  title: this.$i18n.t('notification.columnTemplate.deleteSuccess'),
                  duration: 5000
                };

                if (!(res.status === 'success')) {
                  _context8.next = 16;
                  break;
                }

                _context8.next = 12;
                return this.getColumnTemplates();

              case 12:
                this.updateSelectedTemplateId(templateName);

                _elementUi.Notification.success(message);

                _context8.next = 18;
                break;

              case 16:
                message.title = this.$i18n.t('notification.columnTemplate.deleteFailed');

                _elementUi.Notification.error(message);

              case 18:
                this.resetVariables();

              case 19:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function deleteCurrentTemplate() {
        return _deleteCurrentTemplate.apply(this, arguments);
      }

      return deleteCurrentTemplate;
    }()
  }, {
    key: "resetVariables",
    value: function resetVariables() {
      var _this7 = this;

      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var templateName = null;

      if (this.$orderColumnTemplates.length === 0 || this.selectedTemplateName === 'newTemplate') {
        templateName = null;
      } else {
        templateName = this.helper.get(this.$orderColumnTemplates.find(function (t) {
          return t._id === _this7.selectedTemplateName;
        }), '_id', null);
      }

      this.selectedTemplateName = templateName;
      /*if (this.$orderColumnTemplates.length > 0) {
        const columns = [...this.$orderColumnTemplates[this.$orderColumnTemplates.length - 1].data.columns];
        this.$selectedColumns = this.helper.cloneDeep(columns);
        this.unselectedColumns = this.helper.difference(this.$defaultOrderColumns, this.$selectedColumns);
      }*/

      if (templateName === null) {
        this.selectedTemplateName = 'newTemplate';
        this.$selectedColumns = (0, _toConsumableArray2.default)(this.$defaultOrderColumns);
        this.unselectedColumns = [];
      }

      this.newTemplateName = '';
      this.isDialogVisible = false;
      window.localStorage.setItem(this.columnKey, templateName);
    }
  }]);
  return LMDOrderTableColumnSelectorComponent;
}((0, _vuePropertyDecorator.Mixins)(_lastMileV.LastMileDeliveryMixin));

(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('isDialogVisible')], LMDOrderTableColumnSelectorComponent.prototype, "onDialogVisibleChanges", null);
LMDOrderTableColumnSelectorComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LMDOrderTableColumnSelectorComponent',
  components: {
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-dialog': _elementUi.Dialog,
    'el-tooltip': _elementUi.Tooltip,
    'el-button': _elementUi.Button,
    'el-card': _elementUi.Card,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'draggable': _vuedraggable.default,
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'el-input': _elementUi.Input
  }
})], LMDOrderTableColumnSelectorComponent);
var _default = LMDOrderTableColumnSelectorComponent;
exports.default = _default;